const bigScreenNavData = [
	{
		title: 'Home',
		icon: 'https://www.datocms-assets.com/64336/1742830139-glu-dashboard-sidebar-icons-01.png',
		link: '/elearning/',
	},
	{
		title: 'Webinars',
		icon: 'https://www.datocms-assets.com/64336/1742830044-glu-dashboard-sidebar-icons-03.png',
		subcategories: [
			{
				title: 'Upcoming Webinars',
				link: '/elearning/webinars/#upcomingWebinars',
				icon: 'https://www.datocms-assets.com/64336/1742830044-glu-dashboard-sidebar-icons-03.png',
			},
			{
				title: 'HR Webinars Catch-Ups',
				link: '/elearning/webinars/#webcastHR',
				icon: 'https://www.datocms-assets.com/64336/1742830044-glu-dashboard-sidebar-icons-03.png',
			},
			{
				title: 'H&S Webinars Catch-Ups',
				link: '/elearning/webinars/#webcastHS',
				icon: 'https://www.datocms-assets.com/64336/1742830044-glu-dashboard-sidebar-icons-03.png',
			},
		],
	},
	{
		title: 'Legal',
		icon: 'https://www.datocms-assets.com/64336/1744292706-glu-dashboard-sidebar-icons-06.png',
		subcategories: [
			{
				title: ' General Legal',
				link: '/elearning/legal/',
				icon: 'https://www.datocms-assets.com/64336/1744292706-glu-dashboard-sidebar-icons-06.png',
			},
			{
				title: 'Tribunal Navigator',
				link: '/elearning/tribunal-navigator/',
				icon: 'https://www.datocms-assets.com/64336/1744292719-glu-dashboard-sidebar-icons-07.png',
			},
		],
	},
	{
		title: 'Shorts',
		icon: 'https://www.datocms-assets.com/64336/1742829977-glu-dashboard-sidebar-icons-04.png',
		link: '/elearning/glu-shorts',
	},
	{
		title: 'Podcasts',
		icon: 'https://www.datocms-assets.com/64336/1742829679-glu-dashboard-sidebar-icons-05.png',
		link: '/elearning/glu-talk/',
	},
];
export default bigScreenNavData;
